<div class="modal-content"
    [ngClass]="{'-dynamic-height': dynamicHeight, '-shadow': shadowTop || shadowBottom, '-dimmed-bg': dimmedBg, '-full-paddings': fullPaddings}"
    directive-scroll (onScrollInit)="handleScrollInit($event)" (onScrollY)="handleScrollY($event)">
    <div class="modal-content__inner" [ngClass]="{'-center': center}" directive-height-adjust="source"
        [targetId]="'modal-'+modalData.id">
        <div class="modal-content__scroll">
            <ng-content></ng-content>
        </div>
    </div>
</div>

<div class="modal-content__shadow -top" *ngIf="shadowTop"></div>
<div class="modal-content__shadow -bottom" *ngIf="shadowBottom"></div>